import { render } from "./desc.vue?vue&type=template&id=76248f94&scoped=true"
import script from "./desc.vue?vue&type=script&lang=js"
export * from "./desc.vue?vue&type=script&lang=js"

import "./desc.vue?vue&type=style&index=0&id=76248f94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76248f94"]])

export default __exports__